<template>
  <div id="app" class="gb">
	<router-view class="subwin"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html,body{
	margin: 0;
	padding: 0;
}
#app {
	height:100vh;
}
.subwin{
	background-color: white;
}
.gb{
	/*background-image: url("./assets/images/login-background.jpg");*/
	background-size: 100% 100%;
}
</style>
